import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constantvalues } from "../../const";
import { environment } from "../environments/environment.development";
import { DtoSystemMessage} from "../../models/notifications.model";
import { Observable } from 'rxjs';
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})

export class SystemMessagesService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getMessages(payload: any): Observable<DtoSystemMessage[]>{
        return this.httpClient.get<DtoSystemMessage[]>(`${this.baseURL}${constantvalues.API_URL.GET_MESSAGE_LOGS}`, {params: payload});
    }

    updateMessage(payload: DtoSystemMessage): Observable<DtoSystemMessage>{
         return this.httpClient.put<DtoSystemMessage>(`${this.baseURL}${constantvalues.API_URL.SAVE_MESSAGE_LOG}`, payload);
    }

    deleteMessage(systemMessageId: number): Observable<boolean>{
         return this.httpClient.delete<boolean>(`${this.baseURL}${constantvalues.API_URL.SAVE_MESSAGE_LOG}/${systemMessageId}`);
    }

    preview_message(systemMessage: string): Observable<string> {
        return this.httpClient.post(
            `${this.baseURL}${constantvalues.API_URL.PREVIEW_MESSAGE}`,
            JSON.stringify(systemMessage),
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                responseType: 'text'
            }
        );
        }

}